import React, {
  forwardRef,
  RefObject,
  useState,
  useImperativeHandle,
  useLayoutEffect,
} from 'react'
import { Button, Modal } from 'react-bootstrap'
import { IModalReference } from '../models/References'
import { Answer, MessageType } from '../models/Enum'

interface IProps {
  onShow?: () => void
  onHide?: () => void
  onAnswer: (answer: Answer) => void
  message: string
  title: string
  messageType: MessageType
  showModal?: boolean
}

function MessageModal(props: IProps, ref: RefObject<IModalReference>) {
  const [showModal, setShowModal] = useState(false)

  useLayoutEffect(() => {
    if (props.showModal != null && props.showModal !== showModal) {
      if (props.showModal) {
        show()
      } else {
        hide()
      }
    }
  }, [props.showModal])

  useImperativeHandle(ref, () => ({
    show: () => {
      show()
    },
    hide: () => {
      hide()
    },
  }))

  const show = () => {
    if (!showModal) {
      setShowModal(true)
      if (!!props.onShow) {
        props.onShow()
      }
    }
  }

  const hide = () => {
    if (!!showModal) {
      setShowModal(false)
      if (!!props.onHide) {
        props.onHide()
      }
    }
  }

  const answerClick = (answer: Answer) => {
    props.onAnswer(answer)
    hide()
  }

  const renderButtons = () => {
    return (
      <React.Fragment>
        {(props.messageType === MessageType.YesNo ||
          props.messageType === MessageType.YesNoCancel) && (
          <Button variant='primary' onClick={() => answerClick(Answer.Yes)}>
            Ja
          </Button>
        )}
        {(props.messageType === MessageType.YesNo ||
          props.messageType === MessageType.YesNoCancel) && (
          <Button variant='secondary' onClick={() => answerClick(Answer.No)}>
            Nee
          </Button>
        )}
        {(props.messageType === MessageType.Ok ||
          props.messageType === MessageType.OkCancel) && (
          <Button variant='primary' onClick={() => answerClick(Answer.Ok)}>
            Ok
          </Button>
        )}
        {(props.messageType === MessageType.OkCancel ||
          props.messageType === MessageType.YesNoCancel) && (
          <Button
            variant='secondary'
            onClick={() => answerClick(Answer.Cancel)}
          >
            Annuleren
          </Button>
        )}
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      {showModal && (
        <Modal
          show={showModal}
          onHide={() => answerClick(Answer.Cancel)}
          animation={false}
          className='modal-stack3'
        >
          <Modal.Header closeButton>
            <Modal.Title>{props.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{props.message}</Modal.Body>
          <Modal.Footer>{renderButtons()}</Modal.Footer>
        </Modal>
      )}
    </React.Fragment>
  )
}

export default forwardRef(MessageModal)
